import { gql } from '@apollo/client'

export default gql`
    query quotesList(
        $limit: Int!
        $sort: CreatedAtSortKey
        $offset: Int
        $filter: QuoteAttributeFilterType
        $isCpqFlagV2Enabled: Boolean = false
    ) {
        me {
            id
            hasSecurePlusMemberships
            quotes(
                limit: $limit
                sort: $sort
                offset: $offset
                filter: $filter
            ) {
                totalCount
                items {
                    ... on Quote {
                        id
                        name
                        type
                        status
                        lastModified
                        isEligibleForFreeShipping
                        platformOrder {
                            id
                            name
                            purchaserEmail
                            purchasedDate
                            purchaserUserId
                        }
                        subTotalInCents
                        earliestValidUntilDate
                        slowestShipDateEstimate
                        isOverseasShipping
                        isQuotePurchasable
                        isLocked
                        isCpqOwned
                        isCpqQuote @include(if: $isCpqFlagV2Enabled)
                        cpqQuote @include(if: $isCpqFlagV2Enabled) {
                            sfdcId
                            platformQuote {
                                id
                            }
                            quotePdfUrl
                            orderTotal
                            partsCount
                            moldCount
                            orderQuantity
                        }
                        beganCheckoutAt
                        isExpired
                        expiration
                        depositInCents
                        productionPartsSubtotalInCents
                        moldToolSubtotalInCents
                        isQuoteInRfqState
                        zipCode
                        isTaxExempt
                        partsSummary
                        numberOfParts
                        user {
                            id
                            email
                        }
                        team {
                            id
                            name
                        }
                        businessAccountDiscount {
                            id
                            percent
                            isActive
                            endAt
                        }
                        quoteAttachments {
                            totalCount
                            items {
                                id
                                latestAttachmentRevision {
                                    id
                                }
                            }
                        }
                        quoteModels(limit: 5) {
                            totalCount
                            items {
                                id
                                selectedQuoteModelRevision {
                                    id
                                    state
                                    fileName
                                    dfmFeedback {
                                        id
                                        accepted
                                        severity
                                    }
                                    attachmentLink {
                                        id
                                        quoteAttachmentRevision {
                                            id
                                        }
                                    }
                                    processesDetails {
                                        totalPrice {
                                            ... on ExactPrice {
                                                unitPriceInCents
                                                priceInCents
                                            }
                                            ... on EstimatedPrice {
                                                lowPriceInCents
                                                lowUnitPriceInCents
                                                highPriceInCents
                                                highUnitPriceInCents
                                            }
                                        }
                                    }
                                    quantityRangeStatus
                                    modelConfiguration {
                                        id
                                        productionLeadTime {
                                            productionDays
                                        }
                                        material {
                                            ... on Material {
                                                id
                                                name
                                            }
                                            ... on UserEnteredMaterial {
                                                id
                                                name
                                                process {
                                                    id
                                                    name
                                                }
                                            }
                                        }
                                        process {
                                            id
                                            name
                                        }
                                        color {
                                            id
                                            name
                                        }
                                        colorCode
                                        quantity
                                    }
                                }
                            }
                        }
                        project {
                            id
                            name
                            isSecurePlus
                        }
                    }
                    ... on BasicQuote {
                        id
                        name
                        project {
                            isSecurePlus
                            name
                            id
                        }
                    }
                }
            }
        }
    }
`
